<template>
  <el-select
    clearable
    filterable
    :value="value"
    @input="updateValue"
    :placeholder="$t(placeholder)"
    @clear="updateValue(undefined)"
  >
    <el-option
      v-for="item in list"
      :key="item[valueField]"
      :label="item[textField]"
      :value="item[valueField]"
    ></el-option>
  </el-select>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  created: function () {
    this.fetchData();
  },
  methods: {
    fetchData() {
      var that = this;
      this.action(this.params).then(function (response) {
        if (!response.data.errorCode) {
          that.list = response.data.data;
        }
      });
    },
    updateValue(val) {
      this.$emit("input", val);
    },
  },
  watch: {
    params: function (newValue, oldValue) {
      if (JSON.stringify(oldValue) != JSON.stringify(newValue)) {
        this.fetchData();
      }
    },
  },
  props: {
    action: { type: Function, required: true },
    textField: { type: String, required: true },
    valueField: { type: String, required: true },
    value: { required: true },
    placeholder: { type: String, default: "message.please_select" },
    params: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// DropdownSelect.vue?9e9bab5c